import { Component, input } from '@angular/core';
import { RouterModule } from '@angular/router';

export interface IBreadcrumb {
  label: string;
  url?: string;
}

@Component({
  selector: 'app-breadcrumb',
  imports: [RouterModule],
  templateUrl: './breadcrumb.html',
  styleUrl: './breadcrumb.css',
})
export class Breadcrumb {
  items = input<IBreadcrumb[]>([]);
  showLastRoute = input<boolean>(true);
}
